<template>
<div>
    <section class="position-relative pt-12 pt-md-14 pb-10">
        <div class="container" style="max-width: 900px;">
            <h1 class="display-4 fw-bold mb-3">{{ $route.meta.title }}</h1>
            <p class="lead text-muted mb-7">{{ $route.meta.description }}</p>
            <!-- Same list the SSR fallback renders: config.CONTACT_CHANNELS via /api/site-contacts. -->
            <ul class="list-unstyled">
                <li v-for="channel in channels" :key="channel.url" class="mb-5">
                    <div class="fw-bold">{{ channel.label }}</div>
                    <a :href="channel.url">{{ channel.value }}</a>
                    <div v-if="channel.note" class="text-muted">{{ channel.note }}</div>
                </li>
            </ul>
        </div>
    </section>
</div>
</template>

<script>
export default {
    data() {
        return { channels: [] }
    },
    created() {
        this.$services.SiteContacts().get().then(resp => {
            this.channels = resp.body.channels || []
        }).catch(() => {})
    },
}
</script>
